import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClientService } from './http-client.service';
import { Observable } from 'rxjs';
import { SueldoBasico } from '../models/sueldo-basico';
import { Concepto } from '../models/concepto';
import { DateSelectionModelChange } from '@angular/material/datepicker';

const baseUrl = environment.hostService + '/SueldoBasico';
const baseUrlEstructura = environment.hostService + '/EstructuraSalarial';

@Injectable({
  providedIn: 'root'
})
export class SueldoBasicoService {

  constructor(private _http: HttpClientService) { }

  getAll(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/Index' })
  }

  getByPersonalId(personalId: number): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/GetByPersonalId/' + personalId })
  }

  getHistoryByPersonalId(personalId: number): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/GetHistoryByPersonalId/' + personalId })
  }

  save(sueldo: SueldoBasico, sueldoBasicoConcepto: Concepto[], cortarRegistro: boolean): Observable<any>
  {
    sueldo.sueldoBasicoConcepto = sueldoBasicoConcepto;
    return this._http.post<any>({ url: baseUrl + '/Save/' + cortarRegistro, body: sueldo });
  }

  delete(id: number)
  {
    return this._http.get<any>({ url: baseUrl + '/Delete?id=' + id });
  }

  deleteConcepto(id: number)
  {
    return this._http.get<any>({ url: baseUrl + '/DeleteConcepto?id=' + id });
  }

  guardarConcepto(data): Observable<any>
  {
    return this._http.post<any>({ url: baseUrl + '/UpdateConcepto', body: data, cacheMins: 0 });
  }

  getEstructuraSalarial(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrlEstructura + '/GetDetallesParaSueldoBasico/' })
  }

  getEstructuraSalarialByPais(pais): Observable<any>
  {
    return this._http.get<any>({ url: baseUrlEstructura + '/GetDetallesParaSueldoBasicoByPais?paisid=' + pais })
  }

  aplicarEstructura(estructuraSalarialId: number, sueldoBasicoId: number, sueldoBasico: SueldoBasico)
  {
    const body = { sueldoBasicoId: sueldoBasicoId, estructuraSalarialId: estructuraSalarialId, sueldoBasico: sueldoBasico };
    return this._http.post<any>({ url: baseUrl + '/AplicarEstructura', body, cacheMins: 0 });
  }

  mostrarEstructura(estructuraSalarialId: number, fechaVer: Date, sueldoBasicoId: number, sueldoBasico: SueldoBasico)
  {
    const body = { sueldoBasicoId: sueldoBasicoId, fechaVer: fechaVer, estructuraSalarialId: estructuraSalarialId, sueldoBasico: sueldoBasico };
    return this._http.post<any>({ url: baseUrl + '/MostrarEstructura', body, cacheMins: 0 });
  }

  getFormatoImportacion() {
    const formato = [
      { personal: 0,
        desde: '00/00/0000',
        hasta: '00/00/0000',
        estructuraSalarialId: '', 
        nivel: '',
        subNivel: '',
        errores: ['No Completar']}
    ];

    //estructuraSalarialId, nivel, subNivel se deben validar que existan

    return formato;
  }
  
}

